import styled, { css } from 'styled-components';

export const Row = styled.div`
  ${({ theme, $paddingBottom }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: ${$paddingBottom ? '48px' : '48px 48px 0px'};
    align-items: flex-start;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      padding: ${$paddingBottom ? '20px' : '20px 20px 0px'};
    }
  `}
`;

export const Column = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    max-width: 600px;

    @media (max-width: ${theme.breakpoints.md}) {
      max-width: 100%;
    }
  `}
`;

export const FaqTitle = styled.h4`
    ${({ theme }) => css`
      color: ${theme.v2.colors.neutral.lowDark};
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.lg};
      font-weight: ${theme.v2.font.weights.regular};
      margin: auto 0px;
      max-width: 430px;
      padding: 115px 0px 0px 32px;

      @media (max-width: ${theme.v2.breakpoints.md}) {
       font-size: ${theme.v2.font.sizes.md};
       max-width: unset;
       padding: 0px;
       margin-bottom: 24px;
      }
    `}
`;

export const FaqItemsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: auto 0px;
    padding: 16px 32px 16px 0px;

    #accordion-header div {
      font-size: ${theme.v2.font.sizes.xs};
    }

      @media (max-width: ${theme.v2.breakpoints.md}) {
       padding: 0px;
      }
  `}
`;
